import { selectByMode } from "./mode";

const config = {
  localhost: {
    url: "http://localhost:3010",
  },
  dev: {
    url: "https://dev.api.connect.lesateliersoo.fr",
  },
  production: {
    url: "https://api.connect.lesateliersoo.fr",
  },
  test: {
    // Absolute unreachable host so unmocked e2e/unit requests fail fast (ECONNREFUSED)
    // instead of resolving relative to the page origin and hitting the dev server.
    url: "http://localhost:9999",
  },
  demo: {
    url: "http://localhost:3010",
  },
};

export default selectByMode(config);
